export default "__VITE_ASSET__DICK2C2$__"